import React, { PropsWithChildren } from 'react';

import {
    DEFAULT_TOTAL_DOTS, LoaderDotAnimation
} from './loader-dots.styled';

export type LoaderDotsProps = PropsWithChildren<{
    /**
     * Number of dots to be displayed.
     */
    totalDots?: number
    /**
     * Size of the dots in a number of pixels.
     */
    dotSize?: number
    /**
     * Spacing between the dots in a number of pixels.
     */
    dotSpacing?: number
    /**
     * The total duration of the animation in seconds.
     */
    duration?: number
    /**
     * Helper attribute convention for testing libraries.
     */
    'data-testid'?: string
}>;

/**
 * Visual loading indicator which displays a horizontal row of dots and
 * animates their color and size.
 */
export function LoaderDots ({
    totalDots = DEFAULT_TOTAL_DOTS,
    duration = 4,
    dotSize = 10,
    dotSpacing = 15,
    'data-testid': dataTestId = 'LoaderDots'
}: LoaderDotsProps) {
    return (
        <LoaderDotAnimation
            data-testid={dataTestId}
            totalDots={totalDots}
            dotSize={dotSize}
            dotSpacing={dotSpacing}
            duration={duration}
        >
            {Array.from(Array(totalDots)).map(
                (_, index) => {
                    return (<div key={index} />);
                }
            )}
        </LoaderDotAnimation>
    );
}
